// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  padding-left: 1.5em;
  padding-right: 1.5em;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
}
.container .form-header .title {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
}
.container .timer-form {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  background: var(--ion-color-secondary);
}
.container .timer-form .description {
  text-align: center;
  margin-bottom: 10px;
}
.container .timer-form .form-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.container .timer-form ion-input {
  height: auto;
  max-width: 56px;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  --padding-start: 0;
  border-radius: 10px;
  margin-right: 20px;
  border: 1px solid var(--ion-color-primary);
}
.container .form-content {
  margin-bottom: 20px;
}

.form-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.form-header ion-icon {
  font-size: 2rem;
}

.timer-container {
  padding: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
  min-height: 70vh;
}

.timer-display {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5em;
  font-weight: bold;
  z-index: 1; /* Ensure the text is above the progress bar */
  color: var(--ion-color-primary);
}

:host ::ng-deep app-circular-progress .progress-container {
  width: 300px;
  height: 300px;
}

.set-info {
  text-align: center;
  margin-top: 10px;
}
.set-info p {
  margin: 5px;
  font-size: 1.5em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tabata-timer/tabata-timer.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;AACR;AAEI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;AAAR;AAEQ;EACI,kBAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AADZ;AAIQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;AAFZ;AAMI;EACI,mBAAA;AAJR;;AAQA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AALJ;AAOI;EACI,eAAA;AALR;;AASA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AANJ;;AASA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;EAEA,UAAA,EAAA,8CAAA;EACA,+BAAA;AAPJ;;AAWI;EACI,YAAA;EACA,aAAA;AARR;;AAYA;EACI,kBAAA;EACA,gBAAA;AATJ;AAUI;EACI,WAAA;EACA,gBAAA;AARR","sourcesContent":[".container {\n    display: flex;\n    padding-left: 1.5em;\n    padding-right: 1.5em;\n    justify-content: center;\n    align-items: center;\n    min-height: 70vh;\n\n    .form-header .title {\n        text-align: center;\n        font-size: 2rem;\n        font-weight: bold;\n    }\n\n    .timer-form {\n        display: flex;\n        width: 100%;\n        height: 100%;\n        flex-direction: column;\n        justify-content: space-between;\n        background: var(--ion-color-secondary);\n\n        .description {\n            text-align: center;\n            margin-bottom: 10px;\n        }\n\n        .form-row {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin-top: 20px;\n        }\n\n        ion-input {\n            height: auto;\n            max-width: 56px;\n            text-align: center;\n            font-size: 1.5rem;\n            font-weight: bold;\n            --padding-start: 0;\n            border-radius: 10px;\n            margin-right: 20px;\n            border: 1px solid var(--ion-color-primary);\n        }\n    }\n\n    .form-content {\n        margin-bottom: 20px;\n    }\n}\n\n.form-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n\n    ion-icon {\n        font-size: 2rem;\n    }\n}\n\n.timer-container {\n    padding: 1em;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n    height: 100%;\n    min-height: 70vh;\n}\n\n.timer-display {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 5em;\n    font-weight: bold;\n    // color: var(--ion-text-color);\n    z-index: 1; /* Ensure the text is above the progress bar */\n    color: var(--ion-color-primary);\n}\n\n:host ::ng-deep {\n    app-circular-progress .progress-container {\n        width: 300px;\n        height: 300px;\n    }\n}\n\n.set-info {\n    text-align: center;\n    margin-top: 10px;\n    p {\n        margin: 5px;\n        font-size: 1.5em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
